
import { useState } from "react";
import {Button, TextField } from "@mui/material";
import MessageSuccess from "../messages/messageSuccess";
import MessageError from "../messages/messageError";
import api from "../services/api";
import Editor from "../ckeditor/editor";
import ButtonLeft from "../utils/buttonLeft";
import InputDocUpload from "../utils/inputFileUpload/inputDocUpload";
import { useSelector } from "react-redux";


export default function CreateRelatorioEspontaneo({ processoId, modelName, handleClose }) {
    const user = useSelector((state) => state.account.user);
    const [messageSuccess, setMessageSuccess] = useState('')
    const [messageError, setMessageError] = useState('')
    const [relatorio, setRelatorio] = useState('')
    const [open, setOpen] = useState(false)

    async function HandleChangeFile(file, name) {
        setRelatorio((prevCadastro) => ({ ...prevCadastro, [name]: file }))
    }


    const sendRelatorio = async () => {
        setOpen(true)
        setMessageSuccess('')
        setMessageError('')

        const formData = new FormData();
        formData.append('processoId', processoId);
        formData.append('modelName', modelName?? '');
        formData.append('nome', relatorio?.nome ?? 'sem título');
        formData.append('descricao', relatorio?.conteudo ?? 'sem descrição');
        formData.append('anexo', relatorio?.anexoRelatorio);
        formData.append('userId', user?._id);

        await api.post('/relatorio/create', formData)
            .then(response => {
                setOpen(false)
                setMessageSuccess('Relatório salvo com sucesso')

                setTimeout(() => {
                    handleClose()
                }, 5000);


            }).catch(error => {
                // console.log(error)
                setOpen(false)
                setMessageError(error.response.data.message)
            })
    }

    return (
        <>
            {messageSuccess && <MessageSuccess message={messageSuccess} />}
            {messageError && <MessageError message={messageError} />}

            <TextField
                type="text"
                fullWidth
                label="Título do Relatório"
                variant="outlined"
                margin="normal"
                value={relatorio?.nome || ''}
                onChange={(e) => setRelatorio((prevState) => ({ ...prevState, nome: e.target.value }))}
            />

            <Editor
                setEditorData={setRelatorio}
                editorData={relatorio?.descricao}
            />

            {/* ANEXAR DOCUMENTOS COMPLEMENTARES */}
            <InputDocUpload
                imputLigth={true}
                fullWidth={true}
                onFileSelect={HandleChangeFile}
                inputName={'anexoRelatorio'}
                inputDescription={'Anexo'}
                inputTitle={'Adicionar anexo'}
            />

            <ButtonLeft
                title={'Salvar Relatório'}
                disabled={!relatorio?.anexoRelatorio || open}
                funcao={sendRelatorio}
                load={open}
            >
                <Button color='error' onClick={handleClose} size="small">
                    Cancelar
                </Button>
            </ButtonLeft>
        </>
    )
}